export enum ESaveSortMode {
  SSM_Name,
  SSM_Time,
}

export const ESaveSortModeDisplayName = {
  [ESaveSortMode.SSM_Name]: 'Name',
  [ESaveSortMode.SSM_Time]: 'Time',
};
